import {cs} from "../../../../../../../react/chain-services";
import {ConfirmCancel} from "../../common/confirm-cancel";
import {cx} from "emotion";
import * as React from "react";

export const Buttons = ({onNext, onCancel}) => <>

    {cs(
        ["confirmCancel", (_, next) => ConfirmCancel({next})],
        ({confirmCancel}) => (
            <button {...{
                className: cx("cancel", {}),
                onClick: async () => {
                    if (await confirmCancel()) {
                        onCancel();
                    }
                },
                "xd-qa-type": "button",
                "xd-qa-name": "Coop Condo List Back",
            }}>
                Back
            </button>
        )
    )}
    <button {...{
        className: cx("next", {}),
        disabled: !onNext,
        onClick: () => {
            onNext();
        },
        "xd-qa-type": "button",
        "xd-qa-name": "Coop Condo List Next",
    }}>
        Next
    </button>
</>;
